import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Form, Button, Container, Row, Col, Accordion } from "react-bootstrap";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
// import NotFound from './NotFound';
import { useForm } from "react-hook-form";
import logo from "./logo.svg";

import Swal from "sweetalert2";
import "./App.css";
import Footer from "./components/Footer";
import Loading from "./components/Loading";
import { getConfig } from "./config";

const config = getConfig();
function Questionnaire({}) {
  const { id } = useParams(); // Get the ID from the URL
  const navigate = useNavigate(); // For programmatic navigation
  const [questionnaireData, setQuestionnaireData] = useState();
  const [isLoading, setIsLoading] = useState(true);
  const [submittedData, setSubmittedData] = useState(null);
  const [currentFormData, setCurrentFormData] = useState(null);
  const [error, setError] = useState(null);
  const [submissionData, setSubmissionData] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    watch,
  } = useForm({
    defaultValues: {
      questionnaires: id,
    },
  });

  // Pay attention to the imputs
  const formData = watch();

  const loadSubmissionData = () => {
    try {
      const base64Data = localStorage.getItem("submissionData");
      if (base64Data) {
        const jsonData = atob(base64Data);
        const parsedData = JSON.parse(jsonData);
        setSubmissionData(parsedData);
      }
    } catch (error) {
      console.error("Error retrieving data from localStorage:", error);
    }
  };

  // Get Data
  useEffect(() => {
    const fetchQuestionnaire = async () => {
      setIsLoading(true);
      setError(null);

      try {
        const response = await fetch(`${config.apiOrigin}/questionnaire/${id}`); // Fetch questionnaire data from API

        if (!response.ok) {
          // throw new Error("Questionnaire not found");
           Swal.fire({
            icon: "info",
            title: "Status:",
            text: "Looks like this questionnaire is closed",
          });
        }

        const data = await response.json();
        setQuestionnaireData(data.questionnaire);
      } catch (error) {
        setError(error);
        // navigate("/404"); // Redirect to 404 page if not found
      } finally {
        setIsLoading(false);
        loadSubmissionData();
      }
    };

    fetchQuestionnaire();
  }, [id, navigate]);

  // Callback version of watch.  It's your responsibility to unsubscribe when done.
  useEffect(() => {
    const subscription = watch((value, { name, type }) => {
      // console.log(value, name, type)
      setCurrentFormData(value);
    });
    return () => subscription.unsubscribe();
  }, [watch]);

  const doesAnyQuestionContainAnswers = (data) => {
  if (!data || typeof data !== 'object') {
    return false;
  }

  // 1. Get all category arrays (the values of the top-level object)
  const categoryArrays = Object.values(data);

  // 2. Iterate through each category array using .some() for efficiency
  return categoryArrays.some(questionArray => {
    if (!Array.isArray(questionArray)) {
      return false; // Skip if it's not a valid question array
    }

    // 3. Check if any question in the current array has a valid answers object
    return questionArray.some(question => {
      return (
        question &&
        typeof question.answers === 'object' &&
        question.answers !== null &&
        !Array.isArray(question.answers) // Ensures it's an object, not an array
      );
    });
  });
};

  useEffect(() => {
    if (submittedData) {
      const defaultValues = {
        first_name: submittedData.first_name,
        last_name: submittedData.last_name,
        birthdate: submittedData.birthdate,
        gender: submittedData.gender,
        email_address: submittedData.email_address,
      };

      submittedData.answers.forEach((answer) => {
        if (answer.answer_id) {
          const question = questionnaireData.questions.find(
            (q) => q.id === answer.question_id
          );
          var answerValue = "";

          if (doesAnyQuestionContainAnswers(question)) {
            answerValue = question.answers.find(
              (a) => a.id === answer.answer_id
            )?.value;
          }
          defaultValues[`question_${answer.question_id}`] = answerValue;
        } else {
          defaultValues[`question_${answer.question_id}`] = answer.value;
        }
      });

      reset(defaultValues); // Repopulate form fields
    }

    document.querySelectorAll(".collapse").forEach((element) => {
      element.classList.add("show");
    });
  }, [submittedData, questionnaireData?.questions, reset]);

  // Store formattedData in localStorage as base64 JSON
  useEffect(() => {
    if (questionnaireData?.questions) {
      // Retrieve data from localStorage and repopulate form
      try {
        const base64Data = localStorage.getItem("questionnaireData");
        if (base64Data) {
          const jsonData = atob(base64Data);
          const parsedData = JSON.parse(jsonData);
          setSubmittedData(parsedData);
        }
      } catch (error) {
        console.error("Error retrieving data from localStorage:", error);
      }
    }
  }, [questionnaireData?.questions]);

  const clearSessionData = () => {
    localStorage.clear(questionnaireData);
    localStorage.clear(submissionData);
    reset();
  };

  const warningAlert = (data) => {
    Swal.fire({
      icon: "warning",
      title: "Oops...",
      text: "Looks like you have already submitted this form!",
      html: `<strong>Looks like you have already submitted this form!</strong><br/><br/><p>${JSON.stringify(
        data
      )}</p>`,
      showCancelButton: true,
      confirmButtonText: "Clear Submission",
    }).then((result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
        clearSessionData();
        Swal.fire("Cleared old submission!", "", "success");
      } else if (result.isDenied) {
        Swal.fire("Changes are not saved", "", "info");
      }
    });
  };

  const clearSessionDataSwal = (data) => {
    Swal.fire({
      icon: "warning",
      title: "Clear all data...",
      text: "Are you sure you want to clear",
      showCancelButton: true,
      confirmButtonText: "Clear Form",
    }).then((result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
        clearSessionData();
        Swal.fire("Cleared form!", "", "success");
      }
    });
  };

  // Check to see if they already submitted
  // useEffect(() => {
  //   if (submissionData) {
  //     warningAlert(submissionData);
  //   }
  // });

  if (isLoading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>Error: {error.message}</div>;
  }

  if (!questionnaireData) {
    return <div>Questionnaire not found</div>;
  }

  // const handleChange = (event) => {
  //   try {
  //     const formData = {
  //       first_name: document.getElementById("first_name").value,
  //       birthdate: document.getElementById("birthdate").value,
  //       gender: document.getElementById("gender").value,
  //       email_address: document.getElementById("email_address").value,
  //       answers: [],
  //     };

  //     questionnaireData.questions.forEach((question) => {
  //       if (question.answers.length > 0) {
  //         const selectedAnswer = document.querySelector(
  //           `input[name="question_${question.question_index}"]:checked`
  //         )?.value;
  //         const answerId = question.answers.find(
  //           (answer) => answer.value === selectedAnswer
  //         )?.id;
  //         formData.answers.push({
  //           question_id: question.question_index,
  //           answer_id: answerId,
  //         });
  //       } else {
  //         formData.answers.push({
  //           question_id: question.question_index,
  //           value: document.getElementById(`question_${question.question_index}`).value,
  //         });
  //       }
  //     });

  //     const jsonData = JSON.stringify(formData);
  //     const base64Data = btoa(jsonData);
  //     localStorage.setItem("questionnaireData", base64Data);
  //   } catch (error) {
  //     console.error("Error storing data in localStorage:", error);
  //   }
  // };

  const errorAlert = (e) => {
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: "Looks like you forgot some fields!",
    });
  };

  const successAlert = (data) => {
    Swal.fire({
      icon: "success",
      title: "Success!",
      text: data.message,
      footer: data.submission_id,
    });
  };

  const saveLocalState = (data) => {
    setSubmissionData(data);

    // Store submission data in localStorage as base64 JSON
    try {
      const jsonData = JSON.stringify(data);
      const base64Data = btoa(jsonData);
      localStorage.setItem("submissionData", base64Data);
    } catch (error) {
      console.error("Error storing data in localStorage:", error);
    }
  };

  // Make a POST request to the API
  const postData = async (formattedData, currentFormData) => {
    formattedData["submission_data"] = currentFormData;

    try {
      setIsSubmitting(true);
      const response = await fetch(
        `${config.apiOrigin}/questionnaire/${questionnaireData.guid}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formattedData),
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      saveLocalState(data);
      successAlert(data);

      console.log("API Response:", data);
    } catch (error) {
      setIsSubmitting(false);
      console.error("Error posting data to API:", error);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong while submitting the form. Please try again later.",
      });
    }
  };

  const onSubmit = (data) => {
    const formattedData = {
      questionnaire_id: questionnaireData.guid,
      first_name: data.first_name,
      birthdate: data.birthdate,
      gender: data.gender,
      email_address: data.email_address,
      answers: [],
    };

    // Extract answers for questions with IDs
    questionnaireData.questions.forEach((question) => {
      if (question.answers.length > 0) {
        const selectedAnswer = data[`question_${question.question_index}`];
        const answerId = question.answers.find(
          (answer) => answer.value === selectedAnswer
        )?.id;
        formattedData.answers.push({
          question_id: question.question_index,
          answer_id: answerId,
        });
      } else {
        // For open-ended questions, include the value directly
        formattedData.answers.push({
          question_id: question.question_index,
          value: data[`question_${question.question_index}`],
        });
      }
    });
    setSubmittedData(formattedData);
    postData(formattedData, currentFormData);

    console.log("CurrentFormData", currentFormData);
    console.log("SUBMITTED DATA", formattedData); // Log the formatted data

    // Store formattedData in localStorage as base64 JSON
    try {
      const jsonData = JSON.stringify(formattedData);
      const base64Data = btoa(jsonData);
      localStorage.setItem("questionnaireData", base64Data);
    } catch (error) {
      console.error("Error storing data in localStorage:", error);
    }
  };

  // Group questions by category
  const questionsByCategory = questionnaireData.questions.reduce(
    (acc, question) => {
      acc[question.category] = acc[question.category] || [];
      acc[question.category].push(question);
      return acc;
    },
    {}
  );

  const renderQuestion = (question, currentFormData, required = true) => {
    if (question.answers.length === 0) {
      // Open-ended question
      if (
        currentFormData &&
        currentFormData[`question_${question.dependent_question_id}`]?.includes(
          "Yes"
        )
      ) {
        return (
          <Form.Group key={question.question_index} className="mb-3">
            <Form.Label>{question.value}</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              {...register(`question_${question.question_index}`, {
                required: required,
              })}
            />
            {errors[`question_${question.question_index}`] && (
              <Form.Text className="text-danger">
                This field is required
              </Form.Text>
            )}
          </Form.Group>
        );
      } else if (question.dependent_question_id === null) {
        return (
          <Form.Group key={question.question_index} className="mb-3">
            <Form.Label>{question.value}</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              {...register(`question_${question.question_index}`, {
                required: required,
              })}
            />
            {errors[`question_${question.question_index}`] && (
              <Form.Text className="text-danger">
                This field is required
              </Form.Text>
            )}
          </Form.Group>
        );
      }
    } else {
      // Multiple choice question
      return (
        <Form.Group key={question.question_index} className="mb-3">
          <Form.Label>{question.value}</Form.Label>
          {question.answers.map((answer) => (
            <Form.Check
              key={answer.id}
              type="radio"
              label={answer.value}
              id={`question_${question.question_index}_answer_${answer.id}`}
              {...register(`question_${question.question_index}`, {
                required: true,
              })}
              value={answer.value}
            />
          ))}
          {errors[`question_${question.question_index}`] && (
            <Form.Text className="text-danger">
              This field is required
            </Form.Text>
          )}
        </Form.Group>
      );
    }
  };

  const findQuestionIdByValue = (value) => {
    const question = questionnaireData.questions.find(
      (question) => question.question_index === value
    );
    return question ? question.question_index : null;
  };

  const sortCategories = (data) => {
    if (!data || typeof data !== "object") {
      return {};
    }

    const personalInfoKey = "Personal Information";
    const additionalInfoKey = "Additional Information";

    // 1. Get all category names (keys) from the input data
    const categoryKeys = Object.keys(data);

    // 2. Separate the keys into three groups: top, bottom, and middle
    const middleKeys = categoryKeys.filter(
      (key) => key !== personalInfoKey && key !== additionalInfoKey
    );

    // 3. Sort the middle keys alphabetically
    middleKeys.sort();

    // 4. Construct the final ordered list of keys
    let sortedKeys = [];

    // Add Personal Information (top priority) if it exists
    if (categoryKeys.includes(personalInfoKey)) {
      sortedKeys.push(personalInfoKey);
    }

    // Add the alphabetically sorted middle keys
    sortedKeys = sortedKeys.concat(middleKeys);

    // Add Additional Information (bottom priority) if it exists
    if (categoryKeys.includes(additionalInfoKey)) {
      sortedKeys.push(additionalInfoKey);
    }

    // 5. Reconstruct the object using the final sorted key list
    const sortedData = {};
    for (const key of sortedKeys) {
      sortedData[key] = data[key];
    }

    return sortedData;
  };

  const sortedQuestions = sortCategories(questionsByCategory);
  
  return (
    <Container>
      <h1 className="mt-4">{questionnaireData.name}</h1>
      <p>{questionnaireData.description}</p>

      <Form onSubmit={handleSubmit(onSubmit, (e) => errorAlert(e))}>
        <Accordion defaultActiveKey={Object.keys(sortedQuestions)}>
          {Object.entries(sortedQuestions).map(
            ([category, questions], index) => (
              <Accordion.Item
                key={index}
                eventKey={index.toString()}
                style={{
                  display:
                    category === "Personal Information" ||
                    category === "Additional Information" ||
                    (currentFormData && currentFormData.question_3 === "No")
                      ? "block"
                      : "none",
                }}
              >
                <Accordion.Header>{category}</Accordion.Header>
                <Accordion.Body>
                  {category === "Personal Information" && (
                    <>
                      <Row>
                        <Col md={6}>
                          <Form.Group className="mb-3" controlId="first_name">
                            <Form.Label>First Name</Form.Label>
                            <Form.Control
                              type="text"
                              {...register("first_name", { required: true })}
                            />
                            {errors.first_name && (
                              <Form.Text className="text-danger">
                                This field is required
                              </Form.Text>
                            )}
                          </Form.Group>
                        </Col>
                        <Col md={4}>
                          <Form.Group className="mb-3" controlId="last_name">
                            <Form.Label>Last Name</Form.Label>
                            <Form.Control
                              type="text"
                              {...register("last_name", { required: true })}
                            />
                            {errors.last_name && (
                              <Form.Text className="text-danger">
                                This field is required
                              </Form.Text>
                            )}
                          </Form.Group>
                        </Col>
                      </Row>
                      <Row>
                        <Col md={4}>
                          <Form.Group className="mb-3" controlId="birthdate">
                            <Form.Label>Birthdate</Form.Label>
                            <Form.Control
                              type="date"
                              {...register("birthdate", { required: true })}
                            />
                            {errors.birthdate && (
                              <Form.Text className="text-danger">
                                This field is required
                              </Form.Text>
                            )}
                          </Form.Group>
                        </Col>
                        <Col md={4}>
                          <Form.Group
                            className="mb-3"
                            controlId="email_address"
                          >
                            <Form.Label>Email Address</Form.Label>
                            <Form.Control
                              type="email"
                              {...register("email_address", { required: true })}
                            />
                            {errors.email_address && (
                              <Form.Text className="text-danger">
                                This field is required
                              </Form.Text>
                            )}
                          </Form.Group>
                        </Col>

                        <Col md={4}>
                          <Form.Group className="mb-3" controlId="gender">
                            <Form.Label>Gender</Form.Label>
                            <Form.Select
                              {...register("gender", { required: true })}
                            >
                              <option value="">Select Gender</option>
                              <option value="Male">Male</option>
                              <option value="Female">Female</option>
                              <option value="Non-binary">Non-binary</option>
                              <option value="Other">Other</option>
                            </Form.Select>
                            {errors.gender && (
                              <Form.Text className="text-danger">
                                This field is required
                              </Form.Text>
                            )}
                          </Form.Group>
                        </Col>
                        <Row>
                          <Col md={12}>{renderQuestion(questions[0])}</Col>
                        </Row>
                        {currentFormData &&
                          currentFormData.question_1 === "Yes" && (
                            <Row>
                              <Col md={12}>
                                {renderQuestion(questions[1], currentFormData)}
                              </Col>
                            </Row>
                          )}
                        <Row>
                          <Col md={12}>
                            {renderQuestion(questions[2], currentFormData)}
                          </Col>
                        </Row>

                        {currentFormData &&
                          currentFormData.question_3 === "Yes" && (
                            <Row>
                              <Col md={12}>
                                {renderQuestion(questions[3], currentFormData)}
                              </Col>
                            </Row>
                          )}

                        {currentFormData &&
                          currentFormData.question_3 === "Yes" && (
                            <Row>
                              <Col md={12}>
                                {renderQuestion(questions[4], currentFormData)}
                              </Col>
                            </Row>
                          )}
                        {currentFormData &&
                          currentFormData.question_5 === "Yes" && (
                            <Row>
                              <Col md={12}>
                                {renderQuestion(questions[5], currentFormData)}
                              </Col>
                            </Row>
                          )}
                        {currentFormData &&
                          currentFormData.question_3 === "Yes" && (
                            <Row>
                              <Col md={12}>
                                {renderQuestion(questions[6], currentFormData)}
                              </Col>
                            </Row>
                          )}
                        {/* {currentFormData &&
                          currentFormData.question_3 === "yes" && (
                            <Row>
                              <Col md={12}>
                                {renderQuestion(questions[7], currentFormData)}
                              </Col>
                            </Row>
                          )} */}
                      </Row>
                    </>
                  )}
                  {questions.map(
                    (question) =>
                      question.category !== "Personal Information" &&
                      question.category !== "Additional Information" &&
                      currentFormData &&
                      currentFormData.question_3 === "No" && (
                        <Row key={question.question_index}>
                          <Col md={12}>
                            {renderQuestion(
                              question,
                              currentFormData,
                              question.required
                            )}
                          </Col>
                        </Row>
                      )
                  )}

                  {questions.map(
                    (question) =>
                      question.category === "Additional Information" && (
                        <Row key={question.question_index}>
                          <Col md={12}>
                            {renderQuestion(
                              question,
                              currentFormData,
                              question.required
                            )}
                          </Col>
                        </Row>
                      )
                  )}
                </Accordion.Body>
              </Accordion.Item>
            )
          )}
        </Accordion>
        <Container>
          <Row className="pink_button">
            <Button
              disabled={isSubmitting}
              variant="primary"
              type="submit"
              className="mt-4"
              size="lg"
            >
              {isSubmitting && <span>Submitted</span>}
              {!isSubmitting && <span>Submit</span>}
            </Button>
          </Row>
          <Row>
            <Button
              onClick={clearSessionDataSwal}
              disabled={isSubmitting}
              variant="secondary"
              className="mt-4"
              type="button"
              size="lg"
            >
              Clear Form
            </Button>
          </Row>
        </Container>
      </Form>
    </Container>
  );
}

function App() {
  // const { id } = useParams(); // Get the ID from the URL

  return (
    <Router>
      <Routes>
        <Route path="/questionnaires/:id" element={<Questionnaire />} />
        {/* <Route path="/404" element={<Loading />} /> */}
        {/* <Route path="/404" element={<NotFound />} /> */}
        {/* Add other routes as needed */}
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;
